export const ACCESS_TOKEN = 'accessToken';
export const CMS_TOKEN = 'cmsToken';
export const TIME_DIFFERENCE = 'TIME_DIFFERENCE';
export const I18_NEXT_LNG = 'i18nextLng';

export const SET_TOKEN = 'SET_TOKEN';
export const USER_NAME = 'USER_NAME';
export const USER_LOGIN_METHOD = 'USER_LOGIN_METHOD';
export const USER_DEFAULT_AREA = 'USER_DEFAULT_AREA';
export const USER_AREA_LIST = 'USER_AREA_LIST';

export const OIDC_NEXT_ACTION = 'OIDC_NEXT_ACTION';

export const SIM_ROOT = 'SIM_ROOT';

export const SET_WEBSITE_LIST = 'SET_WEBSITE_LIST';
export const WEBSITE_SELECTED = 'WEBSITE_SELECTED';
export const WEBSITE_ID = 'WEBSITE_ID';
export const WEBSITE_CODE = 'WEBSITE_CODE';

export const WEBSITE_ACTIVE_FLAG = {
  True: '1',
  False: '0'
};

export const SET_WEBSITE_NAVIGATIONS = 'SET_WEBSITE_NAVIGATIONS';

export const SET_USER_INFORMATION = 'SET_USER_INFORMATION';
export const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';
export const USER_AREA_LANGUAGES_OPTIONS = 'USER_AREA_LANGUAGES_OPTIONS';
export const USER_LANGUAGE_OPTIONS = 'USER_LANGUAGE_OPTIONS';
export const OPEN_ICIVET_AUTHORIZE_DIALOG = 'OPEN_ICIVET_AUTHORIZE_DIALOG';
export const REMENBER_ME = 'REMENBER_ME';
export const OIDC_NEXT_URL = 'OIDC_NEXT_URL';

export const CATALOG_CODE = 'CATALOG_CODE';

export const GLOBAL_KEY = 'GLOBAL_KEY';

export const SELECT_OPTION_ALL = {
  "value": "",
  "text": "全部",
  "langKey": "",
  "label": "全部",
  "title": "全部"
};

// CMS 欄目CODE
export const GLOBAL_CATALOGS = {
  Home: 'home',
  Navigations: 'global_navigations',
  Banner: 'banner',
  Recommend: 'recommend',
  LatestNews: 'latest_news',
  ServiceSector2: 'service_sector2',
  ServiceApplication: 'service_application',
  ServiceNews: 'service_news',
  Link: 'link',
  FooterLink: 'footer_link',
  FullTextSearch: 'full_text_search',

  Service: {
    Root: 'service_sector'
  },

  Catering: {
    Service: 'catering_service',
    Announcement: {
      List: 'catering_announcement'
    },
    Report: {
      List: 'catering_report'
    },
    Introduction: {
      List: 'restaurant_introduction'
    },
    Consumption: {
      List: 'consumption_records'
    }
  },
  // 交通服務
  Traffic: {
    Service: 'traffic_service',
    Announcement: {
      List: 'traffic_announcement'
    },
  },
  Postal: {
    Service: 'postal_service',
    Announcement: {
      List: 'postal_announcement'
    },
    Mail: {
      List: 'postal_mail'
    }
  },
  Food: {
    Service: 'food_service',
    Announcement: {
      List: 'food_announcement'
    },
    Information: {
      List: 'food_information'
    },
  },
  // 清潔服務
  Clean: {
    Service: 'clean_service',
    Announcement: {
      List: 'clean_announcement'
    },
  },
  // 宿舍服務
  Dormitory: {
    Service: 'accommodation_service',
    Announcement: {
      List: 'accommodation_announcement'
    },
  },
  // 綠化植栽
  Greening: {
    Service: 'greening_plant_service',
    Announcement: {
      List: 'greening_planting_announcement'
    },
  },
  // 節能環保
  Environment: {
    Service: 'energy_environmental',
    Announcement: {
      List: 'energy_environmental_announcement'
    },
  },
  // 報修服務
  Repair: {
    Service: 'repair_service',
    Announcement: {
      List: 'repair_announcement'
    },
    Order: {
      List: 'repair_order'
    },
    // Form: 'repair_order',
  },
  // 祭祀服務
  Worship: {
    Service: 'sacrificial_service',
    Announcement: {
      List: 'sacrificial_announcement'
    },
  },
  // 勞安服務
  Labor: {
    Service: 'labor_safety_services',
    Policy: {
      Report: 'occupational_safety_policy'
    },
    News: {
      List: 'occupational_safety_news'
    },
    Test: {
      Report: 'detection_report',
      DrinkingMachine: {
        List: 'drinking_machine_test_report'
      },
      WorkingEnvironment: {
        List: 'working_environment_test_report'
      },
    },
    FAQS: {
      List: 'safety_health_faqs'
    },
  },

  // 共享辦公
  Coworking: {
    Service: 'coworking_service',
    Resource: {
      List: 'coworking_resources'
    },
    Order: {
      List: 'coworking_order'
    },
    News: {
      List: 'coworking_news'
    }
  },
  // 簽核中心
  SignOff: {
    Root: 'sign_off',
    Waiting: {
      List: 'sign_off_waiting'
    },
    Signed: {
      List: 'sign_off_signed'
    }
  },

  // 關於總務
  About: {
    Root: 'regarding_general_affairs',
    Introduce: {
      List: 'introduce'
    },
    // 服務窗口
    Casement: {
      List: 'contact_channels'
    },
    Stationary: {
      List: 'station_position',
      Article: 'about_station_article',
      Files: 'about_station_files'
    }
  },

  // 消息中心
  Bulletins: {
    Root: 'bulletins',
    LatestNews: {
      List: 'latest_news'
    },
    Announcement: {
      List: 'notification_announcement'
    },
  },

  // 常見問題
  Faqs: {
    Root: 'faqs', // questions
    Affairs: {
      List: 'faqs_affairs'
    },
    Electrical: {
      List: 'faqs_electrical'
    },
    Safety: {
      List: 'faqs_safety_health'
    },
  },

  // 資源與下載
  Documents: {
    Root: 'file_download',
    AffairsForm: {
      List: 'file_download_affairs_form'
    },
    MaterialDownload: {
      List: 'file_download_material_download'
    },
  },

  // 聯繫我們
  Contact: {
    Root: 'contact',
    Us: {
      List: 'contact_us'
    },
  },

  // 勞工安全衛生管理
  Lauan: {
    Root: 'lauan_safety_management',
    Home: 'lauan_safety_home',
    SafetyHealthPlatform: 'lauan_safety_management_platform',
    GeneralAffairsPlatform: 'lauan_general_affairs_platform'
  },
};

export const FULL_DASHBOARD = {
  News: {
    Tabs: 'Dashboard last news tabs',
    Value: 'Dashboard last news value',
    All: 'Dashboard all last news',
    List: 'Dashboard last news list'
  },
};

export const FULL_FAQS = {
  Value: 'Faqs tab value',
  List: 'Faqs data list',
  Loading: 'Faqs data loading',
  Title: 'Faqs search data title',
};

export const FULL_DOCUMENTS = {
  Value: 'Documents tab value',
  List: 'Documents data list',
  Loading: 'Documents data loading',
};

export const FULL_ABOUT = {
  Value: 'About tab value',
  List: 'About data list',
  Loading: 'About data loading',
};

export const FULL_BULLETINS= {
  Value: 'Bulletins tab value',
  Loading: 'Bulletins data loading',
  FilterService: 'Filter service bulletins list',
};


export const FULL_SERVICE = {
  Category: 'Service tabs value',
  Sector: {
    Tree: 'Service Sector tree',
  },
  Catering: {
    Loading: 'Catering data loading',
    Value: 'Catering Service tabs value',
  },
  Postal: {
    Loading: 'Postal data loading',
    Value: 'Postal Service tabs value',
    User: 'Postal Service User',
    List: 'Postal Service content list',
    Record: 'Postal Service content record',
  },
  Repair: {
    Loading: 'Repair data loading',
    Value: 'Repair Service tabs value',
  },
  Labor: {
    Loading: 'Labor data loading',
    Value: 'Labor Service tabs value',
    List: 'Labor Service content list',
    Test: {
      Loading: 'Labor test data loading',
      Value: 'Labor Service Test tabs value',
    }
  },
  Food: {
    Value: 'Food tab value',
    Loading: 'Food data loading',
  },
  Clean: {
    Value: 'Clean tab value',
    Loading: 'Clean data loading',
  },
  Worship: {
    Value: 'Worship tab value',
    Loading: 'Worship data loading',
  },
  Greening: {
    Value: 'Greening tab value',
    Loading: 'Greening data loading',
  },
  Environment: {
    Value: 'Environment tab value',
    Loading: 'Environment data loading',
  },
  Dormitory: {
    Value: 'Dormitory tab value',
    Loading: 'Dormitory data loading',
  },
  Traffic: {
    Value: 'Traffic tab value',
    Loading: 'Traffic data loading',
  },
  Office: {
    Value: 'Office tab value',
    Loading: 'Office data loading',
    CartTable: 'Office Cart data table',
    CartSheet: 'Office Cart data sheet',
    CartList: 'Office Cart data list',
    Receipt: 'Office Receipt data details',
    Form: 'Office Receipt data form',
    ClearReceipt: 'Office Receipt data details clear',
    Order: {
      Value: 'Office apply tab value',
      ApplyList: 'Office apply data list',
      WaitList: 'Office Wait data list',
      DraftList: 'Office Draft data list',
      HistoryList: 'Office History data list',
    },
  },
};

export const FULL_NOTIFICATION = {
  Path: 'Notification Tabs Value',
  ListDrawer: 'Open Or Close Notification List Drawer',
  DetailsDrawer: 'Open Or Close Notification Details Drawer',
  List: 'Notification List',
  UnreadTotal: 'Notification Unread Total',
  UnreadAllTotal: 'The sum of Sys Notification Unread Total And User Notification Unread Total',
  Details: 'Notification Details',
  ReplyDetails: 'Notification Reply Details',
};

export const FULL_SIGNATURE = {
  Value: 'Sign off tab value',
  List: 'Sign off data list',
  Records: 'Sign off data records',
  Details: 'Sign off data details',
  Loading: 'Sign off data loading',
};

export const FACTORY = {
  List: 'Factory List',
  Unit: 'Factory Unit',
  Build: 'Factory build',
  Floor: 'Factory floor',
  Person: 'Factory Person',
  Area: {
    HY: 'HY',
    DP: 'DP',
    MS: 'MS',
    ZS: 'ZS',
    ZS02: 'ZS02',
  },
  SmartCard: {
    List: 'Smart Card Factory List'
  }
};



export const FULL_TABS = {
  List: 'Tabs List',
  About: 'About tabs',
  Bulletins: 'Bulletins tabs',
  Faqs: 'Faqs tabs',
  Documents: 'Documents tabs',
};

export const APP_DATA_TYPE = {
  Arr: 'array',
  Obj: 'object',
  Str: 'string',
  Num: 'number',
  Null: 'null',
  Undefined: 'undefined',
  Fun: 'function'
};
export const FULL_MENUS = {
  Open: 'Open menus'
}
export const FULL_MESSAGE = {
  Open: 'Open message dialog',
  FormOpen: 'Open Form message dialog',
}



// 是否需要详细内容（0不需要，1需要）
export const HAS_DETAILS = {
  True: '1',
  False: '0'
};

export const FULL_FEEDBACK = {
  Loading: 'Feedback data loading',
  Value: 'Feedback tab value',
  List: 'Feedback List',
  Details: 'Feedback Details',
  Create: 'Create Feedback Item',
  Type: 'Feedback Type Dictionary',
  Rating: 'Feedback Rating',
  FormDrawer: 'Open Or Close Feedback Form Drawer',
  ListDrawer: 'Open Or Close Feedback List Drawer',
  DetailsDrawer: 'Open Or Close Feedback Details Drawer',
  EvaluationDrawer: 'Open Or Close EvaluationDrawer Details Drawer',
  UnreadTotal: 'Feedback Unread Total',
};



export const FULL_APPLICATION = {
  List: 'Application List',
  Details: 'Application Details',
  Create: 'Create Application Item',
  Recently: 'Recently Used',
  ApplyList: 'Application Apply List',
  ApplyDetails: 'Application Apply Details',
  ApplyLogs: 'Application Apply Logs',
  CheckOverlay: 'Check Collection Overlay',
  ServiceListGuideSteps: 'Application List Guide Steps',
  ServiceDetailGuideSteps: 'Application Detail Guide Steps',
};



export const FULL_ANNOUNCEMENT = {
  List: 'Get Announcement List',
};

export const FULL_GLOBAL_SEARCH = {
  Loading: 'Global Search List Loading',
  List: 'Global Search List',
  Details: 'Global Search Details',
  Value: 'Global Search Value',
  Keyword: 'Global Search Keyword',
};

export const FULL_SITE_MAP = {
  Faq: 'Set faq default value',
  Notification: 'Set notification default value',
};

export const FULL_PROFILE = {
  Reply: {
    List: 'Get Reply List In Profile'
  },
  Repair: {
    List: 'Get Repair List In Profile'
  },
};

// 應用服務類型
export const PROJECT = {
  code: 'gam_platform',
};

export const SUB_APPLICATION_TYPE = {
  Presets: 'presets',  // 預設
  Subscriptions: 'subscriptions', // 訂閱
  MyApply: 'myApply', // 申請
  Collect: 'collect', // 自定義添加收藏
}
export const LANGUAGE = {
  cn: 'zh_CN',
  tw: 'zh_TW',
  es: 'en_US',
  vn: 'vi_VN',
  jp: 'JP'
};
//
export const SMS = {
  SignIn: '0',
  SignUp: '1',
  ForgetPassword: '2'
};
//
export const EMAIL = {
  SignIn: '2',
  SignUp: '1',
  ForgetPassword: '3'
};

// 性別
export const GENDER = {
  Unknow: 0,
  Male: 1,
  Female: 2
};

// 已讀未讀
export const READ_FLAG = {
  Unread: 0,
  Archived: 1,
};

// 全部/未回復/已回復
export const COMMENT_FLAG = {
  All: '',
  Unreply: 0,
  Replied: 1,
};

// 有無幫助
export const HLEP_FLAG = {
  Fasle: '0', // 没有帮助
  True: '1', // 有帮助
};


export const MATERIAL_FLAG = {
  Complete: 0, // 資料齊全
  Missing: 1,  // 資料不齊全
}
export const SSO_FLAG = {
  True: 1, // 是授權登錄
  False: 0 // 非授權登錄
};

export const REGISTER_TYPE = {
  phone: 1, // 手機注冊
  email: 2 // 郵箱注冊
};
// 是否第三方應用
export const IS_THIRD_FLAG = {
  True: '1',   // 是
  False: '0'  // 非
}
// 是否需要第三方審核
export const IS_THIRD_CHECK = {
  True: '1',  // 需要
  False: '0'   // 不需要
};
// 審核結果
export const AUDIT_STATUS = {
  approved: 'approved', // 已開通
  approving: 'approving', // 審核中
  rejected: 'rejected' // 已拒絕
};

// 是否為附件
export const IS_FILE = {
  True: '1',  // 是
  False: '0'   // 否
};

export const MESSAGE_STATUS = {
  0: 'default',
  1: 'success', // 'primary',
  2: 'success',
  3: 'warning',
  4: 'error'
};
export const ORDER_STATUS = {
  All: 'all',
  Pending: '1',
  Complete: '2',
  Cancelled: '3',
  Refunded: '4'
}

export const USER_STATUS = {
  All: 'all',
  Active: '0',
  Pending: '1', // 待处理
  Banned: '2',  // 禁止
  Rejected: '3'
}

export const ACTION_STATUS = {
  Undisposed: '0', // 未處理
  Untreated: '0', // 未處理
  Pending: '0', // 待处理
  Processing: '1', // 处理中
  Solved: '2', // 已解决
  Processed: '2', // 已處理
  Stop: '3', // 已終止
  Halt: '3', // 已終止
  Refund: '4', // 退回
  Return: '4', // 退回
}

export const REPLY = {
  Required: '1',
  Unrequired: '0'
}

export const SERVICE_OPEN_TYPE = {
  self: 'self',
  blank: 'blank',
  _self: '_self',
  _blank: '_blank'
};

export const FILE_EXTENSION = {
  pdf: 'pdf',
  pptx: 'pptx',
  png: 'png',
  jpg: 'jpg',
  jpeg: 'jpeg',
  gif: 'gif',
  xlsx: 'xlsx',
  xls: 'xls',
  docx: 'docx',
  doc: 'doc',
  txt: 'txt',
  text: 'text',
  video: 'video'
}

export const DICTIONARY = {
  // 信件类别
  BillType: 'bill_type',
  // 寄件类别
  SendType: 'send_type',
  // 所有寄件类别
  SendAllType: 'send_type_all',
  // 信件狀態
  MailStatus: 'mail_status',
  // 資源類型
  OfficeType: 'gam_shareoffice_shareofficeType',
  // 承租類型
  TenancyType: 'gam_shareoffice_tenancy_type',
  // 承租類型
  RentType: 'rent_type',
  // 申请单状态
  ApplyStatus: 'apply_status',
  // 候補状态
  WaitStatus: 'wait_status',
  // 变更状态
  ChangeStatus: 'change_status',
  // 变更類型
  ChangeType: 'change_type',
  // 需求時長
  NeedTimeType: 'need_time_type',
  // 簽核動作
  BpmSignAction: 'bpm_sign_action',
};


export const MAIL_STATUS = {
  Temporary: '0', // 暫存
  Awaiting: '1', // 待寄件
  Sent: '2',  // 已發送/已寄件
  // Mailed: '2', // 已發送/已寄件
  Bounced: '3', // 被退回
  Delivered: '4',  // 已送達
  NotDelivered: '5', // 未送達
  Received: '6', // 已領取
  // Sign: '6',  // 簽收
};

export const MAIL_LETTER_STATUS = {
  0: 'default',
  1: 'primary', // success
  2: 'primary',
  3: 'error', // warning
  4: 'primary',
  5: 'warning',
  6: 'success'
};

export const MAIL_SEND_TYPE = {
  OrdinaryMail: '7', // 平信
  LimitedTimeDeliveryMail: '8',  // 限時達
  AirMail: '9', // 航空郵件
};

export const LETTER_STEP = {
  Single: 'Single',
  Create: 'Create',
  Add: 'Add',
  Inquiry: 'Inquiry',
  Edit: 'Edit',
  View: 'View'
};

export const POSTAL_LETTER = {
  RegisteredLetter: '1',  // 掛號信
  OfficialLetter: '2',  // 公車信
};


export const REPAIR_STATUS = {
  0: 'primary',
  1: 'success',
  2: 'primary',
  3: 'error',
  4: 'primary',
  5: 'error',
  6: 'success'
};


export const COWORKING_MONTH = 30;

// 
export const TODO_STATUS_CODE = {
  cart: 'cart', // 未提交自定義本地

  save: 'save', // 暫存
  signing: 'signing', // 簽核中
  lived: 'lived', // 已入駐
  waitIn: 'waitIn', // 待入駐
  waiting: 'waiting', // 候補中
  passed: 'passed', // 已通過
  terminated: 'terminated', // 已終止
  rejected: 'rejected', // 已拒絕
  
  canceled: 'canceled',  // 已取消
  waitToOk: 'waitToOk', // 候補成功
  waitToFail: 'waitToFail', // 候補失敗
  refunded: 'refunded', // 已退租
};

export const TODO_APPLY_STATUS_CODE = {
  cart: 'cart', // 未提交自定義本地

  save: 'save', // 草稿
  signing: 'signing', // 簽核中
  waitIn: 'waitIn', // 待入駐
  lived: 'lived', // 已入駐
  rejected: 'rejected', // 退回申請人
  refunded: 'refunded', // 已退租
  passed: 'passed', // 已通過
  cancel: 'cancel', // 已取消
  canceled: 'canceled', // 已取消
  terminated: 'terminated', // 已終止
};

export const TODO_WAIT_STATUS_CODE = {
  signing: 'signing',
  waiting: 'waiting',
  rejected: 'rejected', // 退回申請人
  canceled: 'canceled',  // 已取消
  waitToOk: 'waitToOk', // 候補成功
  waitToFail: 'waitToFail', // 候補失敗
  terminated: 'terminated',
};


export const TODO_STATUS = {
  save: 'default', // 暫存
  signing: 'primary', // 簽核中
  waitIn: 'success', // 待入駐
  lived: 'success', // 已入駐
  rejected: 'error', // 已拒絕  // 退回申請人
  refunded: 'error', // 已退租
  canceled: 'error', // 已取消
  terminated: 'error', // 已終止

  waiting: 'primary', // 候補中
  cancel: 'error', // 已取消
  failure: 'error', // 候補失敗
  waitToFail: 'error', // 候補失敗
  waitToOk: 'success', // 候補成功
  passed: 'success', // 已通過
}

export const HISTORY_STATUS = {
  save: 'default', // 暫存
  signing: 'primary', // 簽核中
  waitIn: 'success', // 待入駐
  lived: 'success', // 已入駐
  rejected: 'error', // 已拒絕  // 退回申請人
  refunded: 'default', // 已退租
  canceled: 'default', // 已取消
  terminated: 'error', // 已終止

  waitToOk: 'success', // 候補成功
  waitToFail: 'error', // 候補失敗
}


export const TODO_SIGN_STATUS = {
  Started: 'primary', // 開始
  InProcess: 'primary', // 進行中
  Cancelled: 'error',  // 終止
  Rejected: 'error', // 拒絕
  Completed: 'success', // 完成
  Restarted: 'primary', // 重新發起
}

// 簽核動作
export const TODO_SIGN_ACTION = {
  Y: 'success', // 同意
  R: 'error',  // 拒絕
  start: 'success', // 發起
  restart: 'success', // 重新發起
  cancel: 'error', // 終止
}

export const TODO_ACTION = {
  Arrow: 'Y', // 同意
  Reject: 'R', // 退回
}

// 是否本人
export const IS_SELF = {
  True: '1',
  False: '0',
};

// 需求時長
export const NEEDTIMETYPE = {
  LongDate: '2',
  ShortDate: '1',
};

// 資源類型
export const TENANCY_TYPE = {
  SharingOffice: '1',  // 共享辦公室
  SharingCompany: '2', // 共享公司
};

// 簽核與共享之資源類型單位
export const RENT_TYPE = {
  SharedSeats: 'Shared_seats',  // 共享座位
  IndependenceOffice: 'Independence_office', // 獨立辦公室
};


// 申請單-暫存-送簽
export const OFFICE_APPLY_ACTION = {
  Save: 'saveAndSign',  // 送簽
  Storage: 'save', // 暫存
};

//  是否候補
export const IS_WAIT_FLAG = {
  True: '1',
  False: '0',
};

// 是否只看立即可租用资源
export const CAN_USE_FLAG = {
  True: 'Y',  // 
  False: 'N',
};

// 申請單據類型
export const ORDER_DETAILS_TYPE = {
  Apply: 'ApplyOrder', // 申請單
  Change: 'ChangeOrder', // 變更單
  Wait: 'WaitOrder', // 候補單
  Cart: 'CartOrder', // 自定義緩存本地
};


// 變更類型
export const ORDER_CHANGE_TYPE = {
  Renewal: '1', // 續租
  ExpansionAndReduction: '2', // 擴租or減租
};
export const ORDER_CHANGE_DISABLE = {
  Renewal: 'N',
}


export const WITH_SIGN_CODE = {
  True: 1, // 为1时包含未签核的节点信息
  False: 0, // 为0时不含未签核的节点信息
}